import { jsx as l } from "react/jsx-runtime";
import s from "classnames";
import { forwardRef as d, useMemo as y, cloneElement as b } from "react";
import o from "./index.es783.js";
import { getComponentDisplayName as T } from "./index.es726.js";
import { UtilityMoreIcon as g } from "./index.es457.js";
const C = "circle-button-component", x = d(
  ({
    disabled: r,
    selected: m,
    variant: n = "default",
    icon: t,
    isOnGrayBackground: a,
    testId: c = C,
    isBrand: e,
    ...i
  }, u) => {
    const f = s(o.root, {
      [o.filled]: n === "filled",
      [o.onGrayBackground]: a,
      [o.disabled]: r,
      [o.selected]: m
    }), p = y(() => t ? b(t, {
      color: r ? "disabled" : e ? "primary-brand" : "default-gray",
      outline: r ? "disabled" : e ? "primary-brand" : "default-gray"
    }) : null, [r, t, e]);
    return /* @__PURE__ */ l(
      "button",
      {
        className: f,
        disabled: r,
        "data-testid": c,
        "aria-label": t ? `${T(t)}-circle-button` : "more-circle-button",
        ref: u,
        ...i,
        children: p || /* @__PURE__ */ l(g, {})
      }
    );
  }
);
export {
  C as CIRCLE_BUTTON_DEFAULT_TESTID,
  x as CircleButton
};
//# sourceMappingURL=index.es17.js.map
